export class ContasReceberBulkAlterarFormaRecebimentoRequest {
    public idsParcelas: number[] = [];
    public idFormaRecebimento: number;
}
